import axios from 'axios';
import { push } from 'connected-react-router';
import TagManager from 'react-gtm-module';
import { AnyAction } from 'redux';
import { call, put } from 'redux-saga/effects';
import { RESET_STATE, showError } from './Commons';

export const URL_QUOTE = '/quote';
export const SET_QUOTE_FORM = 'QUOTEFORM/SET';
export const SUBMIT_QUOTE_FORM = 'QUOTE/SUBMIT';
export const SET_QUOTE = 'QUOTE/SET';
export const QUOTING = 'QUOTING';
export const FAIL_QUOTING = 'QUOTING/FAIL';
export const STOP_QUOTING = 'QUOTING/STOP';
export const SELECT_PLAN = 'QUOTE/SELECT';
export const SET_PLAN = 'PLAN/SELECT';

export interface IPlan {
  name: string;
  plan_id: string;
  premium: string;
  premium_monthly: number;
  death: string;
  accident: string;
  sickness: string;
}

export interface IQuoteForm {
  birthdate: string;
  mail: string;
  fullName: any;
  phone: string;
  documentId: string;
  genre: string;
  province: string;
  commune: string;
  region: string;
  address: string;
  addressNumber: string;
  appartmentNumber: string;
}

export interface IQuote {
  id: number;
  consecutive: number;
  branch: number;
  plansWithConsultation: any[];
  plansWithoutConsultation: any[];
}

export const setQuoteForm = (payload: IQuoteForm) => ({
  payload,
  type: SET_QUOTE_FORM,
});

export const setQuote = (payload: IQuote) => ({
  payload,
  type: SET_QUOTE,
});

export const submitQuote = (payload: IQuoteForm) => ({
  payload,
  type: SUBMIT_QUOTE_FORM,
});

export const quoting = () => ({
  type: QUOTING,
});

export const selectedPlan = (payload: IPlan) => ({
  payload,
  type: SELECT_PLAN,
});

export const setSelectedPlan = (payload: IPlan) => ({
  payload,
  type: SET_PLAN,
});

export const failQuoting = () => ({
  type: FAIL_QUOTING,
});

export const stopQuoting = () => ({
  type: STOP_QUOTING,
});

const initialState = {
  data: {
    address: '',
    addressNumber: 0,
    appartmentNumber: 0,
    birthdate: '',
    commune: '',
    documentId: '',
    fullName: '',
    genre: '',
    mail: '',
    phone: '',
    province: '',
    region: '',
  },
  planSelected: {},
  quote: {
    branchOffice: 0,
    control: '',
    ordinal: 0,
    plansWithConsultation: [],
    plansWithoutConsultation: [],
    quoteId: 0,
  },
  submitting: false,
};

export default function quoteReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_QUOTE_FORM:
      return {
        ...state,
        data: action.payload,
      };
    case QUOTING:
      return {
        ...state,
        submitting: true,
      };
    case FAIL_QUOTING:
      return {
        ...state,
        submitting: false,
      };
    case STOP_QUOTING:
      return {
        ...state,
        submitting: false,
      };
    case SET_QUOTE:
      return {
        ...state,
        quote: action.payload,
        submitting: false,
      };
    case SET_PLAN:
      return {
        ...state,
        planSelected: action.payload,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function* doQuote({ payload }: AnyAction) {
  yield put(setQuoteForm(payload));
  yield put(quoting());

  try {
    const {
      address,
      addressNumber,
      appartmentNumber,
      birthdate,
      commune,
      documentId,
      fullName,
      genre,
      mail,
      phone,
      province,
      region,
    } = payload;
    const quoteData = {
      address,
      addressNumber: addressNumber + '',
      appartmentNumber: appartmentNumber ? appartmentNumber + '' : 'No indica',
      birthdate,
      commune,
      documentId,
      fullName,
      genre,
      mail,
      phone,
      province,
      region,
    };

    const leadUrl = `${process.env.REACT_APP_STOREQUOTE_API_URL}`;

    yield call(axios.post, leadUrl, quoteData);

    yield put(stopQuoting());
    yield put(push('/emit'));
  } catch (error) {
    yield put(showError());
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvErrorP1',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
    yield put(stopQuoting());
  }
}

export function* selectPlan({ payload }: AnyAction) {
  yield put(setSelectedPlan(payload));
  yield put(push('/emit'));
}
